module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "margin-top": "45px"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('div', {
    staticClass: "status"
  }, [_c('span', {
    staticClass: "info-text",
    staticStyle: {
      "float": "right",
      "margin-right": "5px",
      "margin-top": "-1px"
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearStatus($event)
      }
    }
  }, [_vm._v("CLOSE")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "box-label",
    attrs: {
      "data-intro": "Write your Markdown here"
    }
  }, [_vm._v("MARKDOWN")]), _vm._v(" "), _c('span', {
    staticClass: "info-text",
    staticStyle: {
      "float": "right",
      "margin-left": "2px"
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clear($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Clear")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.myInput),
      expression: "myInput"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "markdown"
    },
    domProps: {
      "value": (_vm.myInput)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.myInput = $event.target.value
      }, _vm.update]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "box-label",
    attrs: {
      "data-intro": "View your document updates in real-time as you type."
    }
  }, [_vm._v("RESULT")]), _vm._v(" "), _c('span', {
    staticClass: "info-text",
    staticStyle: {
      "float": "right",
      "margin-left": "2px"
    }
  }, [_c('a', {
    attrs: {
      "href": "",
      "data-intro": "View your formatted HTML at any time",
      "data-position": "left"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showHTML($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-code-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" RAW HTML")])]), _vm._v(" "), _c('div', {
    staticClass: "markdown-body",
    attrs: {
      "id": "results"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compiledMarkdown)
    },
    on: {
      "change": _vm.areaChange
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "margin-top": "40px",
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "well text-center",
    staticStyle: {
      "height": "160px"
    },
    attrs: {
      "data-intro": "Have your own Markdown (.md) file? Load it right here.",
      "data-position": "top"
    }
  }, [_c('h4', {
    staticClass: "option-button"
  }, [_vm._v("Load Markdown (.md)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('input', {
    staticClass: "custom-file-input",
    attrs: {
      "type": "file",
      "id": "fileInput"
    },
    on: {
      "change": _vm.loadMd
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "well text-center",
    staticStyle: {
      "height": "160px"
    },
    attrs: {
      "data-intro": "Ready to export? Save as html, markdown, or plain text.<br><br>Note: All formatting is removed when saved as plain text.",
      "data-position": "top"
    }
  }, [_c('h4', {
    staticClass: "option-button"
  }, [_vm._v("Save Result As ...")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-default btn-save first",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveMd($event)
      }
    }
  }, [_vm._v("Markdown (.md)")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-save",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveTxt($event)
      }
    }
  }, [_vm._v("Plain Text (.txt)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-default btn-save first",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveStyledHtml($event)
      }
    }
  }, [_vm._v("Styled (.html)")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-save",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveRawHtml($event)
      }
    }
  }, [_vm._v("Raw (.html)")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "status-text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "error",
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-text hidden-xs",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "left",
      "title": "Tooltip on left"
    }
  }, [_c('a', {
    staticClass: "pop",
    attrs: {
      "href": "",
      "id": "whatIsMarkdown",
      "data-title": "What is Markdown?",
      "data-content": "Markdown is a lightweight markup language with plain text formatting syntax. Markdown is often used to format readme files, to write messages in online discussion forums, and to create rich text using a plain text editor. Markdown is easily converted to HTML.<br/><br/>For more information, please see:<br/><br/><a href='https://en.wikipedia.org/wiki/Markdown'>https://en.wikipedia.org/wiki/Markdown</a><br><br><a href='https://help.github.com/articles/basic-writing-and-formatting-syntax'>https://help.github.com/articles/basic-writing-and-formatting-syntax</a><br><br>",
      "data-placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" What is Markdown?")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3481be94","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 204
// module chunks = 1